var map = {
	"./CSRealCase1-en-moblie.jpg": 560,
	"./CSRealCase1-en.jpg": 561,
	"./CSRealCase1-moblie.jpg": 562,
	"./CSRealCase1.jpg": 563,
	"./CSRealCase2-en-moblie.jpg": 564,
	"./CSRealCase2-en.jpg": 565,
	"./CSRealCase2-moblie.jpg": 566,
	"./CSRealCase2.jpg": 567,
	"./CSRealCase3-en-moblie.jpg": 568,
	"./CSRealCase3-en.jpg": 569,
	"./CSRealCase3-moblie.jpg": 570,
	"./CSRealCase3.jpg": 571,
	"./CommonInternetWhalingAttacks1.jpg": 572,
	"./CommonInternetWhalingAttacks2.jpg": 573,
	"./CommonInternetWhalingAttacks3.jpg": 574,
	"./CommonInternetWhalingAttacks4.jpg": 575,
	"./CustomerRealCase1-en-moblie.jpg": 576,
	"./CustomerRealCase1-en.jpg": 577,
	"./CustomerRealCase1-moblie.jpg": 578,
	"./CustomerRealCase1.jpg": 579,
	"./E-commerceRealCase1-en.jpg": 580,
	"./E-commerceRealCase1-moblie-en.jpg": 581,
	"./E-commerceRealCase1-moblie.jpg": 582,
	"./E-commerceRealCase1.jpg": 583,
	"./E-commerceRealCase2-en.jpg": 584,
	"./E-commerceRealCase2-mobile.jpg": 585,
	"./E-commerceRealCase2-moblie-en.jpg": 586,
	"./E-commerceRealCase2-moblie.jpg": 587,
	"./E-commerceRealCase2.jpg": 588,
	"./FinanceRealCase-en.jpg": 589,
	"./FinanceRealCase-mobile-en.jpg": 590,
	"./FinanceRealCase-mobile-sc.jpg": 591,
	"./FinanceRealCase-mobile.jpg": 592,
	"./FinanceRealCase-sc.jpg": 593,
	"./FinanceRealCase.jpg": 594,
	"./FinanceRealCase2-en.jpg": 595,
	"./FinanceRealCase2-mobile-en.jpg": 596,
	"./FinanceRealCase2-mobile-sc.jpg": 597,
	"./FinanceRealCase2-mobile.jpg": 598,
	"./FinanceRealCase2-sc.jpg": 599,
	"./FinanceRealCase2.jpg": 600,
	"./HRRealCase-en.jpg": 601,
	"./HRRealCase-mobile-en.jpg": 602,
	"./HRRealCase-mobile.jpg": 603,
	"./HRRealCase.jpg": 604,
	"./ITRealCase1-en.jpg": 605,
	"./ITRealCase1-moblie-en.jpg": 606,
	"./ITRealCase1-moblie.jpg": 607,
	"./ITRealCase1.jpg": 608,
	"./ITRealCase2-en.jpg": 609,
	"./ITRealCase2-moblie-en.jpg": 610,
	"./ITRealCase2-moblie.jpg": 611,
	"./ITRealCase2.jpg": 612,
	"./ITRealCase3-en.jpg": 613,
	"./ITRealCase3-moblie-en.jpg": 614,
	"./ITRealCase3-moblie.jpg": 615,
	"./ITRealCase3.jpg": 616,
	"./IndexPrompt.jpg": 617,
	"./MarketRealCase.jpg": 618,
	"./MarketRealCase1-en-moblie.jpg": 619,
	"./MarketRealCase1-en.jpg": 620,
	"./MarketRealCase1-moblie.jpg": 621,
	"./MarketRealCase1.jpg": 622,
	"./MarketRealCase2-en-moblie.jpg": 623,
	"./MarketRealCase2-en.jpg": 624,
	"./MarketRealCase2-moblie.jpg": 625,
	"./MarketRealCase2.jpg": 626,
	"./MarketRealCase3-en.jpg": 627,
	"./NGORealCase1-en.jpg": 628,
	"./NGORealCase1-moblie-en.jpg": 629,
	"./NGORealCase1-moblie.jpg": 630,
	"./NGORealCase1.jpg": 631,
	"./NGORealCase2-en.jpg": 632,
	"./NGORealCase2-moblie-en.jpg": 633,
	"./NGORealCase2-moblie.jpg": 634,
	"./NGORealCase2.jpg": 635,
	"./RealCase-mobile-en.jpg": 636,
	"./RealCase-mobile-sc.jpg": 637,
	"./RealCase-sc.jpg": 638,
	"./RealCase.mobile.jpg": 639,
	"./Realcase-socialMedia-mobile.jpg": 640,
	"./Realcase-socialMedia.jpg": 641,
	"./a004-a.jpg": 642,
	"./a004-b.jpg": 643,
	"./a004-example1-en.jpg": 644,
	"./a004-example1-sc.jpg": 645,
	"./a004-example1.jpg": 646,
	"./a004-example2.jpg": 647,
	"./a004-example3.jpg": 648,
	"./a008-tip.jpg": 649,
	"./a009-tip1.jpg": 650,
	"./a009-tip2.jpg": 651,
	"./a009-tip3.jpg": 652,
	"./a011-01.jpg": 653,
	"./a011-010.jpg": 654,
	"./a011-011.jpg": 655,
	"./a011-012.jpg": 656,
	"./a011-02.jpg": 657,
	"./a011-03.jpg": 658,
	"./a011-04.jpg": 659,
	"./a011-05.jpg": 660,
	"./a011-06.jpg": 661,
	"./a011-07.jpg": 662,
	"./a011-08.jpg": 663,
	"./a011-09.jpg": 664,
	"./a011-example1.jpg": 665,
	"./a011-example2.jpg": 666,
	"./a011-example3.jpg": 667,
	"./a011-example5.jpg": 668,
	"./a011-example6.jpg": 669,
	"./a011-example7.jpg": 670,
	"./a011-example8.jpg": 671,
	"./a016-1.jpg": 672,
	"./a016-2.jpg": 673,
	"./a016-3.jpg": 674,
	"./a016-4.jpg": 675,
	"./a016-5.jpg": 676,
	"./a016-6.jpg": 677,
	"./a016-market-1.jpg": 678,
	"./a016-market-2.jpg": 679,
	"./a016-market-3.jpg": 680,
	"./a016-market-4.jpg": 681,
	"./a019-tip-en.jpg": 682,
	"./a019-tip.jpg": 683,
	"./a021-viewmore-en.jpg": 684,
	"./a021-viewmore-fsi.jpg": 685,
	"./a021-viewmore.jpg": 686,
	"./a023-short1.jpg": 263,
	"./a023-short2.jpg": 264,
	"./a023-short3.jpg": 265,
	"./a023-short4.jpg": 266,
	"./a023-short5.jpg": 267,
	"./a023-short6.jpg": 268,
	"./a026-example1.jpg": 725,
	"./a026-example2.jpg": 726,
	"./a026-example3.jpg": 727,
	"./a026-example4.jpg": 728,
	"./a026-example5.jpg": 729,
	"./a026-example6.jpg": 730,
	"./a026-example7.jpg": 731,
	"./a028-example1.jpg": 738,
	"./a028-example2.jpg": 739,
	"./a028-example3.jpg": 740,
	"./a037-a.jpg": 741,
	"./a037-b.jpg": 742,
	"./a037-c.jpg": 743,
	"./a037-d.jpg": 744,
	"./a037-e.jpg": 745,
	"./a037-f.jpg": 746,
	"./a037-g.jpg": 747,
	"./a037-h.jpg": 748,
	"./a037-i.jpg": 749,
	"./a037-j.jpg": 750,
	"./a037-k.jpg": 751,
	"./a037-l.jpg": 752,
	"./a037-m.jpg": 753,
	"./a037-n.jpg": 754,
	"./aiSecurityRealcase-en.jpg": 755,
	"./aiSecurityRealcase-mobile-en.jpg": 756,
	"./aiSecurityRealcase-mobile.jpg": 757,
	"./aiSecurityRealcase.jpg": 758,
	"./c001-E-commerce-1.jpg": 759,
	"./c001-E-commerce-2.jpg": 760,
	"./c001-E-commerce-3.jpg": 761,
	"./c001-E-commerce-4.jpg": 762,
	"./c001-E-commerce-5.jpg": 763,
	"./c001-E-commerce-6.jpg": 764,
	"./c001-Picture1.jpg": 765,
	"./c001-Picture2.jpg": 766,
	"./c001-Picture3.jpg": 767,
	"./c001-fsi-1.jpg": 768,
	"./c001-fsi-2.jpg": 769,
	"./c001-fsi-3.jpg": 770,
	"./c001-fsi-4.jpg": 771,
	"./c001-ngo-1.jpg": 772,
	"./c001-ngo-2.jpg": 773,
	"./c001-ngo-3.jpg": 774,
	"./c001-ngo-4.jpg": 775,
	"./c001-ngo-5.jpg": 776,
	"./c001-student-1.jpg": 777,
	"./c001-student-2.jpg": 778,
	"./c001-student-3.jpg": 779,
	"./c001-student-4.jpg": 780,
	"./c001-student-5.jpg": 781,
	"./c001-student-6.jpg": 782,
	"./c001-student-7.jpg": 783,
	"./c001-student-8.jpg": 784,
	"./c002-example1.jpg": 785,
	"./c002-general2024-example1.jpg": 786,
	"./c006-1.jpg": 787,
	"./c006-2.jpg": 788,
	"./c006-3.jpg": 789,
	"./c006-4.jpg": 790,
	"./c006-5.jpg": 791,
	"./c006-6.jpg": 792,
	"./c006-a.jpg": 793,
	"./c006-b.jpg": 794,
	"./c006-c.jpg": 795,
	"./c006-d.jpg": 796,
	"./c007-1.jpg": 797,
	"./c007-bg.jpg": 798,
	"./cert/cert-E-commerce-HKIRC.jpg": 799,
	"./cert/cert-E-commerce-consumer.jpg": 800,
	"./cert/cert-E-commerce-cpttm.jpg": 269,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 801,
	"./cert/cert-customer-HKIRC.jpg": 802,
	"./cert/cert-customer-consumer.jpg": 803,
	"./cert/cert-customer-cpttm.jpg": 270,
	"./cert/cert-customer-hkgcsmeaa.jpg": 804,
	"./cert/cert-finance-HKIRC-sc.jpg": 805,
	"./cert/cert-finance-HKIRC.jpg": 806,
	"./cert/cert-finance-consumer-sc.jpg": 807,
	"./cert/cert-finance-consumer.jpg": 808,
	"./cert/cert-finance-cpttm-sc.jpg": 271,
	"./cert/cert-finance-cpttm.jpg": 272,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 809,
	"./cert/cert-finance-hkgcsmeaa.jpg": 810,
	"./cert/cert-fsi-HKIRC-sc.jpg": 811,
	"./cert/cert-fsi-HKIRC.jpg": 812,
	"./cert/cert-fsi-consumer-sc.jpg": 813,
	"./cert/cert-fsi-consumer.jpg": 814,
	"./cert/cert-fsi-cpttm-sc.jpg": 273,
	"./cert/cert-fsi-cpttm.jpg": 274,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 815,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 816,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 817,
	"./cert/cert-general-staff-HKIRC.jpg": 818,
	"./cert/cert-general-staff-a-HKIRC-sc.jpg": 819,
	"./cert/cert-general-staff-a-HKIRC.jpg": 820,
	"./cert/cert-general-staff-a-consumer-sc.jpg": 821,
	"./cert/cert-general-staff-a-consumer.jpg": 822,
	"./cert/cert-general-staff-a-cpttm-sc.jpg": 275,
	"./cert/cert-general-staff-a-cpttm.jpg": 276,
	"./cert/cert-general-staff-a-hkgcsmeaa-sc.jpg": 823,
	"./cert/cert-general-staff-a-hkgcsmeaa.jpg": 824,
	"./cert/cert-general-staff-consumer-sc.jpg": 825,
	"./cert/cert-general-staff-consumer.jpg": 826,
	"./cert/cert-general-staff-cpttm-sc.jpg": 277,
	"./cert/cert-general-staff-cpttm.jpg": 278,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 827,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 828,
	"./cert/cert-general2024-HKIRC-sc.jpg": 829,
	"./cert/cert-general2024-HKIRC.jpg": 830,
	"./cert/cert-general2024-consumer-sc.jpg": 831,
	"./cert/cert-general2024-consumer.jpg": 832,
	"./cert/cert-general2024-cpttm-sc.jpg": 207,
	"./cert/cert-general2024-cpttm.jpg": 208,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 833,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 834,
	"./cert/cert-hr-HKIRC.jpg": 835,
	"./cert/cert-hr-consumer.jpg": 836,
	"./cert/cert-hr-cpttm.jpg": 279,
	"./cert/cert-hr-hkgcsmeaa.jpg": 837,
	"./cert/cert-it-HKIRC.jpg": 838,
	"./cert/cert-it-consumer.jpg": 839,
	"./cert/cert-it-cpttm.jpg": 280,
	"./cert/cert-it-hkgcsmeaa.jpg": 840,
	"./cert/cert-market-HKIRC.jpg": 841,
	"./cert/cert-market-consumer.jpg": 842,
	"./cert/cert-market-cpttm.jpg": 281,
	"./cert/cert-market-hkgcsmeaa.jpg": 843,
	"./cert/cert-ngo-HKIRC.jpg": 844,
	"./cert/cert-ngo-consumer.jpg": 845,
	"./cert/cert-ngo-cpttm.jpg": 282,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 846,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 847,
	"./cert/cert-senior-manager-HKIRC.jpg": 848,
	"./cert/cert-senior-manager-consumer-sc.jpg": 849,
	"./cert/cert-senior-manager-consumer.jpg": 850,
	"./cert/cert-senior-manager-cpttm-sc.jpg": 283,
	"./cert/cert-senior-manager-cpttm.jpg": 284,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 851,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 852,
	"./cert/cert-startup-HKIRC.jpg": 853,
	"./cert/cert-startup-consumer.jpg": 854,
	"./cert/cert-startup-cpttm.jpg": 285,
	"./cert/cert-startup-hkgcsmeaa.jpg": 855,
	"./cert/cert-student-HKIRC-sc.jpg": 856,
	"./cert/cert-student-HKIRC.jpg": 857,
	"./cert/cert-student-consumer-sc.jpg": 858,
	"./cert/cert-student-consumer.jpg": 859,
	"./cert/cert-student-cpttm-sc.jpg": 286,
	"./cert/cert-student-cpttm.jpg": 287,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 860,
	"./cert/cert-student-hkgcsmeaa.jpg": 861,
	"./dataLeakageRealcase-en.jpg": 862,
	"./dataLeakageRealcase-mobile-en.jpg": 863,
	"./dataLeakageRealcase-mobile.jpg": 864,
	"./dataLeakageRealcase.jpg": 865,
	"./education/topic1000/panelData4.jpg": 223,
	"./education/topic1000/panelData6.jpg": 224,
	"./fsiRealCase1-en.jpg": 866,
	"./fsiRealCase1-mobile-en.jpg": 867,
	"./fsiRealCase1-mobile-sc.jpg": 868,
	"./fsiRealCase1-mobile.jpg": 869,
	"./fsiRealCase1-sc.jpg": 870,
	"./fsiRealCase1.jpg": 871,
	"./fsiRealCase2-en-mobile.jpg": 872,
	"./fsiRealCase2-en.jpg": 873,
	"./fsiRealCase2-mobile-sc.jpg": 874,
	"./fsiRealCase2-mobile.jpg": 875,
	"./fsiRealCase2-sc.jpg": 876,
	"./fsiRealCase2.jpg": 877,
	"./general2024RealCase1-en-mobile.jpg": 878,
	"./general2024RealCase1-en.jpg": 879,
	"./general2024RealCase1-mobile-sc.jpg": 880,
	"./general2024RealCase1-mobile.jpg": 881,
	"./general2024RealCase1-sc.jpg": 882,
	"./general2024RealCase1.jpg": 883,
	"./it900-a031-en.jpg": 884,
	"./it900-a031.jpg": 885,
	"./it900-a32-1.jpg": 886,
	"./it900-a32-2.jpg": 887,
	"./it900-a32-3.jpg": 888,
	"./it930-a033-1.jpg": 889,
	"./it930-a033-2.jpg": 890,
	"./it930-a033-3.jpg": 891,
	"./it930-a033-4.jpg": 892,
	"./it930-a033-5-en.jpg": 893,
	"./it930-a033-5.jpg": 894,
	"./lady-right.jpg": 895,
	"./man-right.jpg": 896,
	"./man.jpg": 897,
	"./news-mobile-en.jpg": 898,
	"./news-mobile-sc.jpg": 899,
	"./news-mobile.jpg": 900,
	"./news-sc.jpg": 901,
	"./news.jpg": 902,
	"./ngo-a035-1.jpg": 903,
	"./ngo-a035-2.jpg": 904,
	"./ngo-a035-3.jpg": 905,
	"./ngo-a035-4.jpg": 906,
	"./ngo-a036-example.jpg": 907,
	"./p-onprogress-B.jpg": 908,
	"./s3-004.jpg": 909,
	"./s3-005.jpg": 910,
	"./s3-006.jpg": 911,
	"./s3-007.jpg": 912,
	"./s3-008.jpg": 913,
	"./startupRealCase1-en.jpg": 945,
	"./startupRealCase1-mobile-en.jpg": 946,
	"./startupRealCase1-mobile.jpg": 947,
	"./startupRealCase1.jpg": 948,
	"./startupRealCase2-en.jpg": 949,
	"./startupRealCase2-mobile-en.jpg": 950,
	"./startupRealCase2-mobile.jpg": 951,
	"./startupRealCase2.jpg": 952,
	"./studentRealCase1-mobile-sc.jpg": 953,
	"./studentRealCase1-sc.jpg": 954,
	"./studentRealCase2-mobile-sc.jpg": 955,
	"./studentRealCase2-sc.jpg": 956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2832;